import {BodyLSecondary, HeadlineXL, LinkXL} from "../../styled-components/Font";
import {MainContentText} from "./text";
import {MainImageContainer, MainRow, MainSection, Maintext} from "./Styled";
import {Title} from "../../styled-components/Base";
import React, {useEffect, useRef, useState} from "react";
import useOnScreen from "../../hooks/useOnScreen";
import {PopupProps} from "../../App";
import Popup from "../Popup/Popup";

export default function MainContent({isPopupOpened, onPopupOpen, onPopupClose, popupText, setPopupText}: PopupProps) {

    const ref = useRef(null)
    const visible = useOnScreen(ref)
    const [isVisible, setIsVisible] = useState(false)
    useEffect(() => {
        if (visible) setIsVisible(true)
    }, [visible])

    return <MainSection ref={ref}>
        <MainRow>
            <Title>

                <HeadlineXL className={isVisible ? 'animation1' : ''}>
                    {MainContentText.title}
                </HeadlineXL>

                <HeadlineXL className={isVisible ? 'animation1' : ''}>
                    {MainContentText.title1}
                </HeadlineXL>

                <HeadlineXL className={isVisible ? 'animation1' : ''}>
                    {MainContentText.title2}
                </HeadlineXL>

                <HeadlineXL className={isVisible ? 'animation1' : ''}>
                    {MainContentText.title3}
                </HeadlineXL>


            </Title>


            <Maintext className={isVisible ? "animation2" : ''}>
                <BodyLSecondary>
                    {MainContentText.text}
                </BodyLSecondary>
                <LinkXL onClick={() => onPopupOpen()}>
                    Запросить презентацию
                </LinkXL>
            </Maintext>
        </MainRow>
        <MainImageContainer>
            <img className={isVisible ? "animation5" : ''} src={'images/Rectangle1691.png'} alt={''}/>
        </MainImageContainer>
        <Popup
            isPopupOpened={isPopupOpened}
            onPopupOpen={onPopupOpen}
            onPopupClose={onPopupClose}
            setPopupText={setPopupText}
            popupText={popupText}
        />
    </MainSection>
}
